import "babel-polyfill";
import Endpoints from '../util/endpoints';

const retry = require('async-retry')

function makeId() {
  let text = "";
  const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (let i = 0; i < 10; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};

async function getSignedRequest(fileKey, type, endpoint) {
  const params = {
    file_name: fileKey,
    file_type: type,
    key: fileKey
  };

  return await $.ajax({
    url: Endpoints[endpoint],
    type: "POST",
    data: JSON.stringify(params)
  });
};

async function uploadFile(file, signed_request) {
  return $.ajax({
    processData: false,
    contentType: file.type,
    url: signed_request,
    type: "PUT",
    data: file
  });
};

async function signAndUpload(file, type, endpoint) {
  const fileKey = makeId();

  return await retry(async () => {
    const { signed_request, url } = await getSignedRequest(fileKey, type, endpoint)
    await uploadFile(file, signed_request);

    return { url, fileKey }
  }, {
    retries: 2
  });
}

async function generateLabel(text, uploadedImage) {
  return await $.ajax({
    url: Endpoints["enlabelEndpoint"] + "/generate_label",
    type: "post",
    data: {
      "custom_text": text,
      "uploaded_image": uploadedImage
    }
  })
}

async function generatePreview(text, uploadedImage, strippedText, emojiEntitiesJSON) {
  return await $.ajax({
    url: Endpoints["enlabelEndpoint"] + "/generate_preview",
    type: "post",
    data: {
      "custom_text": text,
      "uploaded_image": uploadedImage,
      "stripped_text": strippedText, 
      "emoji_entities_string": emojiEntitiesJSON
    }
  })
}

module.exports = {
  signAndUpload,
  generateLabel,
  generatePreview
}
